import { SET_HIGHLIGHTED_FIELDS } from '../types';

export const setHighlightedFields = (fields) => ({
  type: SET_HIGHLIGHTED_FIELDS,
  payload: fields,
});
